"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetricSnapshotBadge = void 0;
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var typestyle_1 = require("typestyle");
var Localize_1 = require("../gen-src/Localize");
var SvgIcon_1 = require("./resources/SvgIcon");
var MetricSnapshotBadge = function (props) {
    var getTooltipContent = function () { return React.createElement("span", null, props.tooltipText); };
    var snapshotBadge = (React.createElement("div", { "data-tb-test-id": "metric-snapshot-badge", className: badgeStyle },
        React.createElement(SvgIcon_1.SvgIcon, { name: SvgIcon_1.SvgIconName.CAMERA, color: BADGE_COLOR, altText: '' }),
        React.createElement("div", { style: textStyle }, Localize_1.Messages.Snapshot())));
    return props.tooltipText ? (React.createElement(widgets_1.Tooltip, { getContent: getTooltipContent, position: widgets_1.TooltipPosition.Bottom }, snapshotBadge)) : (snapshotBadge);
};
exports.MetricSnapshotBadge = MetricSnapshotBadge;
var BADGE_COLOR = '#1277BA';
var badgeStyle = (0, typestyle_1.style)({
    display: 'inline-flex',
    border: "1px solid " + BADGE_COLOR,
    padding: '0 8px 1px 8px',
    alignItems: 'center',
    $nest: {
        '&:focus, &:focus-visible': {
            boxShadow: '0 0 4px 0 #3498db',
            outline: 'none',
        },
    },
});
var textStyle = {
    color: BADGE_COLOR,
    fontSize: '12px',
    float: 'right',
    padding: '2px 0 0 2px',
    lineHeight: 'normal',
};
//# sourceMappingURL=MetricSnapshotBadge.js.map